import React from 'react'

import { BusinessEventsDisabledBanner } from '../../../../../components/BusinessEvent/BusinessEventsDisabledBanner/BusinessEventsDisabledBanner'
import { ZapierPromoBanner } from '../../../../../components/BusinessEvent/ZapierPromoBanner/ZapierPromoBanner'
import { BusinessEventList } from '../../../../../components/BusinessEvent/BusinessEventList/BusinessEventList'

import { useAccount } from '../../../../../common/useAccount'

export const BusinessEventSidebar = () => {
  const { account } = useAccount({ refetchOnMountOrArgChange: false })

  return (
    <div className='d-flex flex-column zocks-gap-1.25 zocks-p-1.5'>
      <ZapierPromoBanner />
      {!account?.effectiveConfig.businessEvent ? <BusinessEventsDisabledBanner /> : null}
      <BusinessEventList />
    </div>
  )
}
